import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { myConnectionsStates } from '../../hooks/useMyConnectionsHook';

const mappingsActions = mapDefaultValuesToActions(myConnectionsStates);

export default reduxReducerHelper(mappingsActions, myConnectionsStates);
